<div style="width: 100%">
  <mat-checkbox [disabled]="isDisable" color="primary" [formControl]="controlName" [checked]="checked"><ng-content></ng-content></mat-checkbox>  
  <mat-label>{{ label }}</mat-label>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</div>
